import { useMemo } from 'react';
import { includedKeyword } from '@seek/related-search-seo';

import { useSERPHasExternalJobs } from 'src/modules/hooks/useSERPHasExternalJobs';
import { useSelector } from 'src/store/react';
import {
  selectJoraCrossLink,
  selectRelatedSearches,
} from 'src/store/selectors';

const useSeoFooter = () => {
  const hasExternalJobs = useSERPHasExternalJobs();
  const partners = useSelector(selectJoraCrossLink);
  const relatedSearches = useSelector(selectRelatedSearches);

  return useMemo(() => {
    const filteredSearches = relatedSearches
      ? relatedSearches.filter(({ keywords }) => includedKeyword(keywords))
      : [];

    return {
      tabIndex: -1,
      filteredSearches,
      hasExternalJobs,
      partners,
      shouldRenderRelatedSearches: Boolean(filteredSearches.length),
      shouldRenderSeoPartners: Boolean(partners?.canCrossLink),
    };
  }, [partners, hasExternalJobs, relatedSearches]);
};

export default useSeoFooter;
